import { appName } from "../../../../core/schema/names/appName.js";

export function createTitle(title?: string): string {
	return title ?? appName;
}
